<div class="row">
    <div class="col-xl-4">
        <div class="card card-box p-4 mb-5">
            <div class="text-center">
                <div class="avatar-icon-wrapper rounded-circle m-0">
                    <div class="d-inline-flex justify-content-center p-0 rounded-circle avatar-icon-wrapper bg-neutral-danger text-danger m-0 d-130">
                        <fa-icon [icon]="['fas', 'times']" class="d-flex align-self-center display-3"></fa-icon>
                    </div>
                </div>
                <h4 class="font-weight-bold mt-4">Are you sure you want to delete this entry?</h4>
                <p class="mb-0 font-size-lg text-muted">You cannot undo this operation.</p>
                <div class="pt-4">
                    <button class="btn btn-pill btn-neutral-secondary mx-1" type="button">
                        <span class="btn-wrapper--label">
                            Cancel
                        </span>
                    </button>
                    <button (click)="Submit()" [ladda]="isLoading" class="btn btn-pill btn-danger mx-1" type="button">
                        <span class="btn-wrapper--label">
                            Delete
                        </span>
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="col-xl-4">
        <div class="card card-box p-4 mb-5">
            <div class="text-center">
                <div class="avatar-icon-wrapper rounded-circle m-0">
                    <div class="d-inline-flex justify-content-center p-0 rounded-circle avatar-icon-wrapper bg-neutral-success text-success m-0 d-130">
                        <fa-icon [icon]="['far', 'lightbulb']" class="d-flex align-self-center display-3"></fa-icon>
                    </div>
                </div>
                <h4 class="font-weight-bold mt-4">Do you want to create this?</h4>
                <p class="mb-0 font-size-lg text-muted">You can later review your options.</p>
                <div class="pt-4">
                    <button class="btn btn-pill btn-neutral-dark mx-1" type="button">
                        <span class="btn-wrapper--label">
                            Cancel
                        </span>
                    </button>
                    <button (click)="Submit()" [ladda]="isLoading" class="btn btn-pill btn-success mx-1" type="button">
                        <span class="btn-wrapper--label">
                            Create
                        </span>
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="col-xl-4">
        <div class="card card-box p-4 mb-5">
            <div class="text-center">
                <div class="avatar-icon-wrapper rounded-circle m-0">
                    <div class="d-inline-flex justify-content-center p-0 rounded-circle avatar-icon-wrapper bg-neutral-first text-first m-0 d-130">
                        <fa-icon [icon]="['far', 'keyboard']" class="d-flex align-self-center display-3"></fa-icon>
                    </div>
                </div>
                <h4 class="font-weight-bold mt-4">Are you sure?</h4>
                <p class="mb-0 text-black-50">You can change your mind later.</p>
                <div class="pt-4">
                    <button class="btn btn-pill btn-neutral-secondary text-danger mx-1" type="button">
                        <span class="btn-wrapper--label">
                            Cancel
                        </span>
                    </button>
                    <button (click)="Submit()" [ladda]="isLoading" class="btn btn-pill btn-first mx-1" type="button">
                        <span class="btn-wrapper--label">
                            Add
                        </span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>